module.exports = __webpack_public_path__ + "img/2020-3min-ch.8c060c45.jpg";